import React from 'react';
import './App.css';
import Header from './Components/Header/Header';
import { TypeDescriptionService, EntityDescription } from './Api/interfaces';
import EntityDescriptionList from './Components/EntityDescriptionList/EntityDescriptionList';
import AuthenticationService from './Services/AuthenticationService'
import EntityDetails from './Components/EntityDetails/EntityDetails';
import DescriptionService from './Services/DescriptionService';
import CheckStatus from './CheckStatus'

interface State {
  entity: EntityDescription | null;
  selected: boolean;
  descriptions: EntityDescription[];
  statusCheck: boolean;
}

interface Props {

}

export default class App extends React.Component<Props, State> {
  private descriptionService: TypeDescriptionService;

  constructor(props: Props) {
    super(props);
    this.state = { selected: false, entity: null, descriptions: null, statusCheck: false };
    this.descriptionService = new DescriptionService();
    AuthenticationService.OnSessionChanged = () => this.onSessionChanged();
  }

  private unSelectPreviousEntity(): void {
    if (this.state.descriptions) {
      this.state.descriptions.forEach((x) => x.isSelected = false);
    }
  }

  private onSessionChanged() {
    this.setState({ descriptions: null, selected: false, entity: null });
    this.loadDescriptions();
  }
  private onChangeByType(typeName: string, isBack = false): void {
    this.unSelectPreviousEntity();
    if (typeName.toLowerCase() === "statuscheck") {
      this.setState({ statusCheck: true });
      return;
    }
    this.descriptionService.getDescriptor(typeName).then((entity) => {
      if (this.state.descriptions) {
        this.state.descriptions.find((x) => x.typeName === entity.typeName).isSelected = true;
      }
      this.setState({ selected: true, entity: entity, statusCheck: false })
      if (!isBack) {
        const path = window.location.pathname;
        const leftPart = path.substring(0, path.lastIndexOf('/'));
        const fullPath = `${leftPart}/${entity.typeName}${window.location.search}`;
        window.history.pushState('', entity.label, fullPath);
      }
    });
  }
  private loadDescriptions() {
    this.descriptionService.getDescriptors().then((de) => {
      this.setState({ descriptions: de });
    });
  }
  componentDidMount(): void {
    this.descriptionService.getDescriptors().then((de) => {
      this.setState({ descriptions: de })
      if (window.location.pathname) {
        const path = window.location.pathname;
        const type = path.substring(path.lastIndexOf('/') + 1);
        if (type) {
          this.onChangeByType(type, false);
        }
      }
    });

    window.onpopstate = (e: any): void => {
      if (e) {
        if (window.location.pathname) {
          const path = window.location.pathname;
          const type = path.substring(path.lastIndexOf('/') + 1);
          if (type) {
            this.onChangeByType(type, true);
          }
        }
      }
    }
  }

  public render(): JSX.Element {
    const { entity: _e, selected: _s, descriptions: _d, statusCheck: _check } = this.state;
    if (!_d) {
      return (<div>Loading...</div>);
    }
    if (_check) {
      return (<CheckStatus />)
    }
    return (
      <div className="App">
        <div id="header"><Header /></div>
        <div id="middle">
          <div id="entityList">
            <EntityDescriptionList descriptions={_d} onTypeClicked={(e) => this.onChangeByType(e)} />
          </div>
          <div id="propertyDetails"> {!_s ? (<div></div>) : (<EntityDetails entity={_e} onTypeClicked={(t) => this.onChangeByType(t)} />)}</div>
        </div>
      </div>
    );
  }
}
